import { useEffect, useState } from 'react';

const DESKTOP_MIN_WIDTH = 992;

const getWindowWidth = () =>
  typeof window === 'undefined' ? 0 : window.innerWidth;

function useWindowSize() {
  const [innerWidth, setInnerWidth] = useState(getWindowWidth);

  useEffect(() => {
    const handleWindowResize = () => setInnerWidth(window.innerWidth);

    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return {
    innerWidth,
    isDesktop: innerWidth >= DESKTOP_MIN_WIDTH,
    isMobile: innerWidth < DESKTOP_MIN_WIDTH,
  };
}

export default useWindowSize;
